import React from "react";
import { Navigate } from "react-router-dom";

const Login = React.lazy(() => import("../pages/auth/Login"));
const ForgotPassword = React.lazy(() => import("../pages/auth/ForgotPassword"));
const UserLogin = React.lazy(() => import("../pages/auth/UserLogin"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const OtpVerification = React.lazy(() => import("../pages/auth/OtpVerification"));
const Dashboard1 = React.lazy(() => import("../pages/dashboard"));
const Customer = React.lazy(() => import("../pages/customer"));
const FittingPartner = React.lazy(() => import("../pages/fittingPartner"));
const Employee = React.lazy(() => import("../pages/employee"));
const Cart = React.lazy(() => import("../pages/cart"));
const Calendar = React.lazy(() => import("../pages/calendars/calendar"));
const Appoinment = React.lazy(() => import("../pages/calendars/appoinment"));
const QuoteManagement = React.lazy(() => import("../pages/quoteManagement"));
const Profile = React.lazy(() => import("../pages/profile"));
const TyreProduct = React.lazy(() => import("../pages/product/typreProduct"));
const CreateTyreProduct = React.lazy(() => import("../pages/product/typreProduct/create"));
const WheelProduct = React.lazy(() => import("../pages/product/wheelProduct"));
const CreateWheelProduct = React.lazy(() => import("../pages/product/wheelProduct/create"));
const BatteryProduct = React.lazy(() => import("../pages/product/batteryProduct"));
const CreateBatteryProduct = React.lazy(() => import("../pages/product/batteryProduct/create"));
const Order = React.lazy(() => import("../pages/order"));
const OrderDetails = React.lazy(() => import("../pages/order/show"));
const UpdateOrderDetails = React.lazy(() => import("../pages/order/UpdateOrderDetails"));
const Report = React.lazy(() => import("../pages/report"));
const Invoice = React.lazy(() => import("../pages/invoice"));
const InvoiceDetails = React.lazy(() => import("../pages/invoice/invoicePreview"));
const StockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases"));
const CreateStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/create"));
const ShowStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/show"));
const UpdateStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/update"));
const StockAdjustments = React.lazy(() => import("../pages/stockManagement/stockAdjustments"));
const Suppliers = React.lazy(() => import("../pages/stockManagement/suppliers"));
const ShowSuppliers = React.lazy(() => import("../pages/stockManagement/suppliers/show"));
const StockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments"));
const CreateStockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments/create"));
const ShowStockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments/show"));
const ExpenseSheets = React.lazy(() => import("../pages/expenseSheets"));
const CreateExpenseSheets = React.lazy(() => import("../pages/expenseSheets/create"));
const ShowExpenseSheets = React.lazy(() => import("../pages/expenseSheets/show"));
const Account = React.lazy(() => import("../pages/account"));
const Error500 = React.lazy(() => import("../pages/Error500"));
const Error404 = React.lazy(() => import("../pages/Error404"));

export const ROUTES = {
  LOGIN: {
    path: "/auth/login",
    element: <Login />,
    isProtected: false,
  },
  FORGOT_PASSWORD: {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
    isProtected: false,
  },
  USER_LOGIN: {
    path: "/auth/user-login",
    element: <UserLogin />,
    isProtected: false,
  },
  LOGOUT: {
    path: "/auth/logout",
    element: <Logout />,
    isProtected: false,
  },
  OTP_VERIFICATION: {
    path: "/auth/otp-verification",
    element: <OtpVerification />,
    isProtected: false,
  },
  DASHBOARD: {
    path: "/dashboard",
    element: <Dashboard1 />,
    isProtected: true,
  },
  PROFILE: {
    path: "/profile",
    element: <Profile />,
    isProtected: true,
  },
  CART: {
    path: "/cart",
    element: <Cart />,
    isProtected: true,
  },
  FITTING_PARTNER: {
    path: "/fitting-partner",
    element: <FittingPartner />,
    isProtected: true,
  },
  EMPLOYEE: {
    path: "/employee",
    element: <Employee />,
    isProtected: true,
  },
  CUSTOMER: {
    path: "/customer/:key",
    element: <Customer />,
    isProtected: true,
  },
  CALENDAR: {
    path: "/calendar",
    element: <Calendar />,
    isProtected: true,
  },
  APPOINMENT: {
    path: "/appoinment",
    element: <Appoinment />,
    isProtected: true,
  },
  QUOTE: {
    path: "/quote",
    element: <QuoteManagement />,
    isProtected: true,
  },
  TYRE_PRODUCT: {
    path: "/product/tyre-product",
    element: <TyreProduct />,
    isProtected: true,
  },
  CREATE_TYRE_PRODUCT: {
    path: "/product/tyre-product/create",
    element: <CreateTyreProduct />,
    isProtected: true,
  },
  WHEEL_PRODUCT: {
    path: "/product/wheel-product",
    element: <WheelProduct />,
    isProtected: true,
  },
  CREATE_WHEEL_PRODUCT: {
    path: "/product/wheel-product/create",
    element: <CreateWheelProduct />,
    isProtected: true,
  },
  BATTERY_PRODUCT: {
    path: "/product/battery-product",
    element: <BatteryProduct />,
    isProtected: true,
  },
  CREATE_BATTERY_PRODUCT: {
    path: "/product/battery-product/create",
    element: <CreateBatteryProduct />,
    isProtected: true,
  },
  ORDER: {
    path: "/order",
    element: <Order />,
    isProtected: true,
  },
  ORDER_DETAILS: {
    path: "/order/order-details",
    element: <OrderDetails />,
    isProtected: true,
  },
  UPDATE_ORDER_DETAILS: {
    path: "/order/update-order-details",
    element: <UpdateOrderDetails />,
    isProtected: true,
  },
  REPORT: {
    path: "/report",
    element: <Report />,
    isProtected: true,
  },
  INVOICE: {
    path: "/invoice",
    element: <Invoice />,
    isProtected: true,
  },
  INVOICE_DETAILS: {
    path: "/invoice/invoice-details",
    element: <InvoiceDetails />,
    isProtected: true,
  },
  STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases",
    element: <StockPurchases />,
    isProtected: true,
  },
  CREATE_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/create",
    element: <CreateStockPurchases />,
    isProtected: true,
  },
  SHOW_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/show",
    element: <ShowStockPurchases />,
    isProtected: true,
  },
  UPDATE_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/update",
    element: <UpdateStockPurchases />,
    isProtected: true,
  },
  STOCK_ADJUSTMENTS: {
    path: "/stock-management/stock-adjustments",
    element: <StockAdjustments />,
    isProtected: true,
  },
  SUPPLIERS: {
    path: "/stock-management/suppliers",
    element: <Suppliers />,
    isProtected: true,
  },
  SHOW_SUPPLIERS: {
    path: "/stock-management/suppliers/show",
    element: <ShowSuppliers />,
    isProtected: true,
  },
  STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments",
    element: <StockPayments />,
    isProtected: true,
  },
  CREATE_STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments/create",
    element: <CreateStockPayments />,
    isProtected: true,
  },
  SHOW_STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments/show",
    element: <ShowStockPayments />,
    isProtected: true,
  },
  EXPENSE_SHEETS: {
    path: "/expense-sheets",
    element: <ExpenseSheets />,
    isProtected: true,
  },
  CREATE_EXPENSE_SHEETS: {
    path: "/expense-sheets/create",
    element: <CreateExpenseSheets />,
    isProtected: true,
  },
  SHOW_EXPENSE_SHEETS: {
    path: "/expense-sheets/show",
    element: <ShowExpenseSheets />,
    isProtected: true,
  },
  ACCOUNT: {
    path: "/account",
    element: <Account />,
    isProtected: false,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  DEFAULT: {
    path: "*",
    element: <Navigate to={"/404"} replace />,
    isProtected: false,
  },
};


export const routes = Object.values(ROUTES);
